import { DateTime } from "luxon";
import { DateLabel, Datewrap, StyledDateInput } from "./styled";

const SEASONS = ["Spring", "Summer", "Fall", "Winter"];

const MemoryDate = ({ date, setDate }) => {
  const dateValue = date.toFormat("yyyy-MM-dd");

  const handleDateChange = (e) => {
    const parsed = DateTime.fromISO(e.target.value);
    if (parsed.isValid) {
      setDate(parsed.startOf("day"));
    }
  };

  return (
    <Datewrap>
      <DateLabel htmlFor="memory-date">A chapter from</DateLabel>
      <StyledDateInput
        id="memory-date"
        type="date"
        value={dateValue}
        max={DateTime.now().toFormat("yyyy-MM-dd")}
        onChange={handleDateChange}
      />
    </Datewrap>
  );
};

export default MemoryDate;
